import { render, staticRenderFns } from "./MultimediaVideos.vue?vue&type=template&id=2c0715cd&"
import script from "./MultimediaVideos.vue?vue&type=script&lang=js&"
export * from "./MultimediaVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports